import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getRestaurantDetails } from "../actions/restaurantActions";
import SwitchOnAndOff from "../components/SwitchOnAndOff";
import Loader from "../components/Loader";
import Messages from "../components/Messages";
import styled from "styled-components";
import SubMenu from "../components/SubMenu";
import {
  updateRestaurant,
  createRestaurant,
} from "../actions/restaurantActions";
import TimeInputLessPlus from "../components/TimeInputLessPlus";
import Separator from "../components/Separator";
import { Row, Col } from "react-bootstrap";
import moment from "moment-timezone";
import DropDownButton from "../components/DropDownButton";
import {
  GoogleMap,
  Marker,
  useLoadScript,
  useJsApiLoader,
} from "@react-google-maps/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquarePhoneFlip } from "@fortawesome/free-solid-svg-icons";
import { getDialCode, getCountryCode } from "../components/CountryCode";
import InputDayOrHour from "../components/InputDayOrHour";
import InputDayOrHourInt from "../components/InputDayOrHourInt";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
/* global google */
import {
  Container,
  CardHeader,
  CardHeaderTitle,
  Input,
  ModernButton,
  SettingsCard,
  SectionTitle,
  Text,
  GridContainer,
  CustomSpan,
  StyledSelect,
} from "../components/DefaultImports";

const getTimezone = () => {
  if (window.Intl && window.Intl.DateTimeFormat) {
    const options = new window.Intl.DateTimeFormat().resolvedOptions();
    return options && options.timeZone ? options.timeZone : "";
  }
  return "";
};

function RestaurantSettingsUpdate({
  creating_restaurant = "no",
  handleNextStep = false,
  restaurant_id = false,
  restaurantCreated = false,
  setCreateRestaurantToFalse = false,
  steps = false,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const params = useParams();
  const [restaurantId, setRestaurantId] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("ok_status");

  const [restaurantName, setRestaurantName] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState(false);

  const [longitudeField, setLongitudeField] = useState(0.0);
  const [latitudeField, setLatitudeField] = useState(0.0);
  const [viewDistance, setViewDistance] = useState(18);

  const [numberOfChairs, setNumberOfChairs] = useState(0);
  const [numberOfBabyChairs, setNumberOfBabyChairs] = useState("");
  const [limitPeopleReservation, setLimitPeopleReservation] = useState("");
  const [limitBabyChairsReservation, setLimitBabyChairsReservation] =
    useState("");
  const [autoAcceptLimit, setAutoAcceptLimit] = useState("");
  const [eachTime, setEachTime] = useState("00:15");
  const [acceptPeoplePerEachTime, setAcceptPeoplePerEachTime] = useState("");
  const [timezone, setTimezone] = useState(getTimezone());
  const timezones = moment.tz.names();
  const [autoAcceptTimeLimit, setAutoAcceptTimeLimit] = useState("");
  const [autoAcceptTimeLimitFuture, setAutoAcceptTimeLimitFuture] =
    useState("");
  const [messageReminderTime, setMessageReminderTime] = useState("");
  const [autoSetTables, setAutoSetTables] = useState(null);
  const [timeToCancelledWarning, setTimeToCancelledWarning] = useState("");
  const [
    stop_allowing_modifications_time_before_date,
    setStop_allowing_modifications_time_before_date,
  ] = useState(0);
  const [
    stop_allowing_cancelling_time_before_date,
    setStop_allowing_cancelling_time_before_date,
  ] = useState(0);

  const [countryCode, setCountryCode] = useState("pt");
  const [restaurant_description, setRestaurant_description] = useState("");
  const [reconfirmation_duration, setReconfirmation_duration] = useState("");
  const [reconfirmation_time_before_date, setReconfirmation_time_before_date] =
    useState("");
  const [sizeError, setSizeError] = useState("");

  const [restaurant_params, setRestaurant_params] = useState({});

  const { isLoaded: isGoogleLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDtPooGWkj4z_ExlO9ggRMwwI9QiFZuZTI",
  });

  const [marker, setMarker] = useState(false);

  const [firstTimeChekcer, setFirstTimeChekcer] = useState(false);

  const [allowGeocode, setAllowGeocode] = useState(false);

  // Set the flag to true after 3 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setAllowGeocode(true);
    }, 3000); // 3000 milliseconds = 3 seconds

    // Cleanup function to clear the timer if the component unmounts
    return () => clearTimeout(timer);
  }, []); // Empty dependency array means this effect only runs once on mount

  // Your existing useEffect, modified to also check for allowGeocode
  useEffect(() => {
    if (allowGeocode && postalCode && isGoogleLoaded) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: postalCode }, (results, status) => {
        if (status === "OK") {
          const location = results[0].geometry.location;
          setLatitudeField(location.lat());
          setLongitudeField(location.lng());
          setMarker({
            lat: location.lat(),
            lng: location.lng(),
          });
        } else {
          console.error(
            "Geocode was not successful for the following reason:",
            status,
          );
        }
      });
    }
  }, [postalCode, isGoogleLoaded]);

  const detectCountryCode = () => {
    const userCountryCode = navigator.language.split("-")[1];
    const formattedCountryCode = userCountryCode
      ? userCountryCode.toLowerCase()
      : "us";
    // Add more specific checks if needed based on the origin or location detection mechanism
    return formattedCountryCode; // Default to 'PT' if the country code is not detected
  };

  const handleOnZoomChanged = React.useCallback((map) => {
    const zoomLevel = map.getZoom();
    setViewDistance(zoomLevel);
  }, []);

  const onMapClick = React.useCallback((event) => {
    setMarker({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    });
    setLatitudeField(event.latLng.lat());
    setLongitudeField(event.latLng.lng());
  }, []);

  const handleOnLoad = (map) => {
    // The google object is available here
    if (isGoogleLoaded) {
      google.maps.event.trigger(map, "resize");
      map.addListener("zoom_changed", () => handleOnZoomChanged(map));
    }
  };

  const restaurantDetails = useSelector((state) => state.restaurantDetails);
  const { restaurants, isLoading, error } = restaurantDetails;

  const generateIntervalOptions = () => {
    const intervalOptions = [];
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 60; j += 15) {
        // Format the hour and minute values to have two digits
        const hour = i.toString().padStart(2, "0");
        const minute = j.toString().padStart(2, "0");
        const time = `${hour}:${minute}`;

        if (time >= "00:15" && time <= "08:00") {
          intervalOptions.push(time);
        }
      }
    }
    return intervalOptions;
  };

  const generateNumberOptions = () => {
    const numberOptions = [];
    for (let i = 0; i < 100; i++) {
      numberOptions.push(i);
    }
    return numberOptions;
  };

  // Usage:
  const [numberOptions, setNumberOptions] = useState(generateNumberOptions());
  const [intervalOptions, setIntervalOptions] = useState(
    generateIntervalOptions(),
  );

  let initialData;

  useEffect(() => {
    if (restaurants) {
      setRestaurantId(restaurants.id);
    }
  }, [restaurants]);

  useEffect(() => {
    if (restaurants && restaurants !== null) {
      setRestaurantName(restaurants.restaurant_name);
      setAddress(restaurants.adress);

      if (
        restaurants.postal_code !== postalCode &&
        restaurants.postal_code !== undefined
      ) {
        setPostalCode(restaurants.postal_code);
      }
      setLatitudeField(parseFloat(restaurants.latitude));
      setLongitudeField(parseFloat(restaurants.longitude));
      setViewDistance(restaurants.view_distance);
      setMarker({
        lat: parseFloat(restaurants.latitude),
        lng: parseFloat(restaurants.longitude),
      });
      setNumberOfBabyChairs(restaurants.number_of_babychairs);
      setLimitPeopleReservation(restaurants.limit_people_reservation);
      setLimitBabyChairsReservation(restaurants.limit_baby_chairs_reservation);
      setEachTime(restaurants.each_time);
      setAutoAcceptLimit(restaurants.auto_accept_limit);
      setAcceptPeoplePerEachTime(restaurants.accept_people_per_each_time);
      setTimezone(restaurants.timezone);
      setAutoAcceptTimeLimit(restaurants.only_auto_accept_before_this_time);
      setAutoAcceptTimeLimitFuture(
        restaurants.only_auto_accept_before_this_time_future,
      );
      setMessageReminderTime(restaurants.send_message_reminder_to_customers);
      setAutoSetTables(restaurants.auto_set_tables);
      setTimeToCancelledWarning(restaurants.time_to_cancelled_warning);
      setRestaurant_description(restaurants.restaurant_description);
      setReconfirmation_duration(restaurants.reconfirmation_duration);
      setReconfirmation_time_before_date(
        restaurants.reconfirmation_time_before_date,
      );
      setStop_allowing_modifications_time_before_date(
        restaurants.stop_allowing_modifications_time_before_date,
      );
      setStop_allowing_cancelling_time_before_date(
        restaurants.stop_allowing_cancelling_time_before_date,
      );

      initialData = {
        restaurantName: restaurants?.restaurant_name,
        address: restaurants?.address,
        postalCode: restaurants?.postal_code,
        latitudeField: parseFloat(restaurants?.latitude),
        longitudeField: parseFloat(restaurants?.longitude),
        viewDistance: restaurants?.view_distance,
        numberOfBabyChairs: restaurants?.number_of_babychairs,
        limitPeopleReservation: restaurants?.limit_people_reservation,
        limitBabyChairsReservation: restaurants?.limit_baby_chairs_reservation,
        eachTime: restaurants?.each_time,
        autoAcceptLimit: restaurants?.auto_accept_limit,
        acceptPeoplePerEachTime: restaurants?.accept_people_per_each_time,
        timezone: restaurants?.timezone,
        autoAcceptTimeLimit: restaurants?.only_auto_accept_before_this_time,
        autoAcceptTimeLimitFuture:
          restaurants?.only_auto_accept_before_this_time_future,
        messageReminderTime: restaurants?.send_message_reminder_to_customers,
        autoSetTables: restaurants?.auto_set_tables,
        timeToCancelledWarning: restaurants?.time_to_cancelled_warning,
        restaurant_description: restaurants?.restaurant_description,
        reconfirmation_duration: restaurants?.reconfirmation_duration,
        reconfirmation_time_before_date:
          restaurants?.reconfirmation_time_before_date,
        stop_allowing_modifications_time_before_date:
          restaurants?.stop_allowing_modifications_time_before_date,
        stop_allowing_cancelling_time_before_date:
          restaurants?.stop_allowing_cancelling_time_before_date,
      };
    }
  }, [restaurants, restaurant_id]);

  const hasChanges = () => {
    const initialData = {
      restaurantName,
      address,
      postalCode,
      latitudeField,
      longitudeField,
      viewDistance,
      numberOfBabyChairs,
      limitPeopleReservation,
      limitBabyChairsReservation,
      eachTime,
      autoAcceptLimit,
      acceptPeoplePerEachTime,
      timezone,
      autoAcceptTimeLimit,
      autoAcceptTimeLimitFuture,
      messageReminderTime,
      autoSetTables,
      timeToCancelledWarning,
      restaurant_description,
      reconfirmation_duration,
      reconfirmation_time_before_date,
      stop_allowing_modifications_time_before_date,
      stop_allowing_cancelling_time_before_date,
    };

    return Object.keys(initialData).some(
      (key) =>
        JSON.stringify(initialData[key]) !== JSON.stringify(restaurants?.[key]),
    );
  };

  // Warn user before leaving the page if changes were made
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (hasChanges()) {
        event.preventDefault();
        event.returnValue =
          "Tem certeza de que deseja sair? As alterações não foram salvas.";
      }
    };

    const handleNavigation = (event) => {
      if (hasChanges()) {
        event.preventDefault();
        const confirmLeave = window.confirm(
          "Tem certeza de que deseja sair? As alterações não foram salvas?",
        );
        if (confirmLeave) {
          window.removeEventListener("beforeunload", handleBeforeUnload);
          navigate(event.detail.to);
        }
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("customNavigation", handleNavigation);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("customNavigation", handleNavigation);
    };
  }, [
    restaurantName,
    address,
    postalCode,
    latitudeField,
    longitudeField,
    viewDistance,
    numberOfBabyChairs,
    limitPeopleReservation,
    limitBabyChairsReservation,
    eachTime,
    autoAcceptLimit,
    acceptPeoplePerEachTime,
    timezone,
    autoAcceptTimeLimit,
    autoAcceptTimeLimitFuture,
    messageReminderTime,
    autoSetTables,
    timeToCancelledWarning,
    restaurant_description,
    reconfirmation_duration,
    reconfirmation_time_before_date,
    stop_allowing_modifications_time_before_date,
    stop_allowing_cancelling_time_before_date,
  ]);

  function checkEmptyStates() {
    let emptyStates = [];

    if (restaurantName === "") {
      emptyStates.push("Nome do restaurante");
    }
    if (!address) {
      emptyStates.push("Morada");
    }
    if (numberOfBabyChairs === "") {
      emptyStates.push("Numero de cadeiras para bebês");
    }
    if (!limitPeopleReservation) {
      emptyStates.push("Limite de pessoas por reserva");
    }
    if (!limitBabyChairsReservation) {
      emptyStates.push("Limite de cadeiras para bebês por reserva");
    }

    if (autoAcceptLimit < 0) {
      emptyStates.push("Aceitação automatica");
    }
    if (!eachTime) {
      emptyStates.push("Cada tempo");
    }
    if (!acceptPeoplePerEachTime) {
      emptyStates.push("Limite de pessoas por tempo");
    }

    if (emptyStates.length > 0) {
      return (
        "Os seguintes campos não estão corretamente preenchidos: " +
        emptyStates.join(", ")
      );
    } else {
      return "ok_status";
    }
  }

  function checkForErrorsAndCreateRestaurant() {
    // Check for validation errors before proceeding
    if (limitPeopleReservation > acceptPeoplePerEachTime) {
      setSizeError(
        "O número máximo de pessoas por grupo não pode ser maior que o total aceito por horário.",
      );
      setShowError(true);
      alert(sizeError);
      return;
    }

    let status_error = checkEmptyStates();
    setErrorMessage(status_error);

    if (status_error === "ok_status") {
      setShowError(false);
      setSizeError(""); // Clear any previous size error

      const updatedRestaurantParams = {
        restaurant_name: restaurantName,
        adress: address,
        postal_code: postalCode,
        latitude: latitudeField,
        longitude: longitudeField,
        view_distance: viewDistance,
        number_of_chairs: numberOfChairs,
        number_of_babychairs: numberOfBabyChairs,
        limit_people_reservation: limitPeopleReservation,
        limit_baby_chairs_reservation: limitBabyChairsReservation,
        auto_accept_limit: autoAcceptLimit,
        accept_people_per_each_time: acceptPeoplePerEachTime,
        each_time: eachTime,
        timezone: timezone,
        only_auto_accept_before_this_time: autoAcceptTimeLimit,
        only_auto_accept_before_this_time_future: autoAcceptTimeLimitFuture,
        send_message_reminder_to_customers: messageReminderTime,
        auto_set_tables: autoSetTables,
        time_to_cancelled_warning: timeToCancelledWarning,
        restaurant_description: restaurant_description,
        reconfirmation_duration: reconfirmation_duration,
        reconfirmation_time_before_date: reconfirmation_time_before_date,
        stop_allowing_modifications_time_before_date:
          stop_allowing_modifications_time_before_date,
        stop_allowing_cancelling_time_before_date:
          stop_allowing_cancelling_time_before_date,
      };

      if (creating_restaurant === "no") {
        dispatch(updateRestaurant(restaurantId, updatedRestaurantParams));
        if (steps) {
          setCreateRestaurantToFalse();
          handleNextStep();
        }
      } else {
        dispatch(createRestaurant(updatedRestaurantParams));
        setCreateRestaurantToFalse();
        handleNextStep();
      }
    } else {
      setShowError(true);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    checkForErrorsAndCreateRestaurant();
  };

  useEffect(() => {
    if (restaurantCreated === true) {
      checkForErrorsAndCreateRestaurant();
    }
  }, [restaurantCreated]);

  useEffect(() => {
    setRestaurant_params({
      restaurant_name: restaurantName,
      adress: address,
      postal_code: postalCode,
      latitude: latitudeField,
      longitude: longitudeField,
      view_distance: viewDistance,
      number_of_chairs: numberOfChairs,
      number_of_babychairs: numberOfBabyChairs,
      limit_people_reservation: limitPeopleReservation,
      limit_baby_chairs_reservation: limitBabyChairsReservation,
      accept_people_per_each_time: acceptPeoplePerEachTime,
      each_time: eachTime,
      only_auto_accept_before_this_time: autoAcceptTimeLimit,
      auto_set_tables: autoSetTables,
      time_to_cancelled_warning: timeToCancelledWarning,
    });
  }, [
    dispatch,
    restaurantName,
    address,
    numberOfChairs,
    numberOfBabyChairs,
    limitPeopleReservation,
    limitBabyChairsReservation,
    autoAcceptLimit,
    eachTime,
    acceptPeoplePerEachTime,
    autoSetTables,
    timeToCancelledWarning,
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const numericValue = Number(value);

    switch (name) {
      case "restaurant_name":
        setRestaurantName(value);
        break;
      case "adress":
        setAddress(value);
        break;
      case "postalCode":
        setPostalCode(value);
        break;
      case "number_of_chairs":
        setNumberOfChairs(numericValue);
        break;
      case "number_of_babychairs":
        setNumberOfBabyChairs(numericValue);
        break;
      case "limit_people_reservation":
        if (numericValue > acceptPeoplePerEachTime) {
          setSizeError(
            "O número máximo de pessoas por grupo não pode ser maior que o total aceito por horário.",
          );
        } else {
          setSizeError("");
        }
        setLimitPeopleReservation(numericValue);
        break;
      case "limit_baby_chairs_reservation":
        setLimitBabyChairsReservation(numericValue);
        break;
      case "auto_accept_limit":
        setAutoAcceptLimit(numericValue);
        break;
      case "accept_people_per_each_time":
        if (numericValue < limitPeopleReservation) {
          setSizeError(
            "O total aceito por horário não pode ser menor que o número máximo de pessoas por grupo.",
          );
        } else {
          setSizeError("");
        }
        setAcceptPeoplePerEachTime(numericValue);
        break;
      case "each_time":
        setEachTime(numericValue);
        break;
      default:
        break;
    }
  };

  const handleIntervalTimeChange = (option) => {
    setEachTime(option);
  };

  const handleTimeCancelWarning = (value) => {
    setTimeToCancelledWarning(value);
  };

  const handleAutoAcceptTimeLimit = (value) => {
    setAutoAcceptTimeLimit(value);
  };

  const handleReconfirmation_time_before_date = (value) => {
    setReconfirmation_time_before_date(value);
  };

  const handleReconfirmation = (value) => {
    setReconfirmation_duration(value);
  };

  const handleMessageReminderTime = (value) => {
    setMessageReminderTime(value);
  };

  useEffect(() => {
    if (restaurants) {
      console.log(
        "latitude: ",
        restaurants.latitude,
        "longitude: ",
        restaurants.longitude,
      );
      console.log(
        "latitudeField: ",
        latitudeField,
        "longitudeField: ",
        longitudeField,
      );
    }
  }, [restaurants]);

  return (
    <Container>
      <Row>
        <Col sm={12} md={12} xl={12}>
          <CardHeader>
            <CardHeaderTitle>Definições</CardHeaderTitle>
          </CardHeader>

          {isLoading ? (
            <Loader />
          ) : error ? (
            <Messages variant="error">{error}</Messages>
          ) : restaurants ? (
            <Form onSubmit={handleSubmit}>
              <GridContainer>
                <SettingsCard>
                  <SectionTitle>Clientes e aceitação automática</SectionTitle>
                  <Text>
                    Número máximo de pessoas por reserva:
                    <CustomSpan />
                    <Input
                      type="number"
                      id="limit_people_reservation"
                      name="limit_people_reservation"
                      value={limitPeopleReservation}
                      onChange={handleChange}
                      min={0}
                    />
                    <CustomSpan />
                    pessoas.
                  </Text>

                  <Text>
                    Aceitar automaticamente grupos até:
                    <CustomSpan />
                    <Input
                      type="number"
                      id="auto_accept_limit"
                      name="auto_accept_limit"
                      value={autoAcceptLimit}
                      onChange={handleChange}
                      min={0}
                    />
                    <CustomSpan />
                    pessoas.
                  </Text>

                  <Text>
                    Aceitar automaticamente reservas com antecedência mínima de:
                    <CustomSpan />
                    <InputDayOrHour
                      initialValue={
                        restaurants.only_auto_accept_before_this_time
                      }
                      setValue={handleAutoAcceptTimeLimit}
                    />
                  </Text>

                  <Text>
                    Aceitar automaticamente reservas com antecedência máxima de:
                    <CustomSpan />
                    <InputDayOrHourInt
                      initialValue={
                        restaurants.only_auto_accept_before_this_time_future
                      }
                      setValue={setAutoAcceptTimeLimitFuture}
                    />
                  </Text>
                </SettingsCard>

                <SettingsCard>
                  <SectionTitle>Edição e cancelamento</SectionTitle>

                  <Text>
                    Permitir edição com antecedência mínima de:
                    <CustomSpan />
                    <InputDayOrHourInt
                      initialValue={
                        restaurants.stop_allowing_modifications_time_before_date
                      }
                      setValue={setStop_allowing_modifications_time_before_date}
                    />
                  </Text>

                  <Text>
                    Permitir cancelamento com antecedência mínima de:
                    <CustomSpan />
                    <InputDayOrHourInt
                      initialValue={
                        restaurants.stop_allowing_cancelling_time_before_date
                      }
                      setValue={setStop_allowing_cancelling_time_before_date}
                    />
                  </Text>
                </SettingsCard>

                <SettingsCard>
                  <SectionTitle>Cadeiras de bebé</SectionTitle>

                  <Text>
                    Quantas cadeiras de bebé existem?
                    <CustomSpan />
                    <Input
                      type="number"
                      id="number_of_babychairs"
                      name="number_of_babychairs"
                      value={numberOfBabyChairs}
                      onChange={handleChange}
                      min={0}
                    />
                  </Text>

                  <Text>
                    Máximo de cadeiras de bebé por grupo:
                    <CustomSpan />
                    <Input
                      type="number"
                      id="limit_baby_chairs_reservation"
                      name="limit_baby_chairs_reservation"
                      value={limitBabyChairsReservation}
                      onChange={handleChange}
                      min={0}
                    />
                  </Text>
                </SettingsCard>

                <SettingsCard>
                  <SectionTitle>Atribuição automática de mesas</SectionTitle>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <SwitchOnAndOff
                      isOn={autoSetTables}
                      handleToggle={() => setAutoSetTables(!autoSetTables)}
                    />
                    <Text style={{ marginLeft: "8px", marginBottom: 0 }}>
                      Atribuir mesas automaticamente às reservas.
                    </Text>
                  </div>
                </SettingsCard>

                <SettingsCard>
                  <SectionTitle>Fuso horário</SectionTitle>
                  <StyledSelect
                    value={timezone}
                    onChange={(e) => setTimezone(e.target.value)}
                  >
                    {timezones.map((tz) => (
                      <option key={tz} value={tz}>
                        {tz}
                      </option>
                    ))}
                  </StyledSelect>
                </SettingsCard>
              </GridContainer>

              {errorMessage !== "ok_status" && (
                <div style={{ color: "red", marginBottom: "10px" }}>
                  {errorMessage}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "20px",
                }}
              >
                <ModernButton color="#EE754C" fontSize="14px" type="submit">
                  Guardar
                </ModernButton>
              </div>
            </Form>
          ) : null}
        </Col>
      </Row>
    </Container>
  );
}

export default RestaurantSettingsUpdate;

const Form = styled.form`
  width: 100%;

  margin: 0 auto;
  padding: 0 10px;
`;

const Button = styled.button`
  display: inline-block;
  font-weight: 400;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-color: #007bff;
  border: 1px solid #007bff;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 4px;

  &:hover {
    background-color: #0069d9;
    border-color: #0062cc;
  }
`;
